module.exports = require('./uniqueInstanceId')
